// src/components/ChatThread.js
// The message list used by the member chats: day dividers, grouped bubbles,
// sending / failed states, tappable photos. Plus the shared jump-to-latest pill.
import { withChatLayout, isImageMessage, imageUrl, timeLabel, seenMessageId } from '../lib/chatUtils'
import './ChatThread.css'

export function JumpToLatest({ show, onClick }) {
  if (!show) return null
  return (
    <button type="button" className="chat-jump" onClick={onClick}>
      ↓ New messages
    </button>
  )
}

export function TypingIndicator({ show, name }) {
  if (!show) return null
  return (
    <div className="chat-typing" aria-live="polite">
      <span className="chat-typing__dots"><i /><i /><i /></span>
      <span>{name} is typing</span>
    </div>
  )
}

export default function ChatThread({
  messages, userId, showSkyAvatar = false, onRetry, onDiscard, onOpenImage,
}) {
  const rows = withChatLayout(messages)
  const seenId = seenMessageId(messages, userId)
  return (
    <>
      {rows.map(row => {
        if (row.type === 'divider') {
          return <div key={row.key} className="chat-day"><span>{row.label}</span></div>
        }
        const { msg, firstInGroup, lastInGroup } = row
        const fromMe = msg.sender_id === userId
        const status = msg._status
        const cls = [
          'chat-bubble-wrap',
          fromMe ? 'chat-bubble-wrap--me' : 'chat-bubble-wrap--sky',
          !firstInGroup && 'chat-bubble-wrap--grouped',
          status === 'sending' && 'chat-bubble-wrap--pending',
        ].filter(Boolean).join(' ')

        return (
          <div key={row.key} className={cls}>
            {!fromMe && showSkyAvatar && (
              lastInGroup ? (
                <div className="chat-bubble-wrap__avatar">
                  <span>S</span>
                  <span className="chat-verified">✦</span>
                </div>
              ) : <div className="chat-avatar-spacer" />
            )}
            <div className={`chat-bubble ${fromMe ? 'chat-bubble--me' : 'chat-bubble--sky'}`}>
              {isImageMessage(msg.content) ? (
                <img src={imageUrl(msg.content)} alt="Shared" className="chat-img"
                  onClick={() => onOpenImage && onOpenImage(imageUrl(msg.content))} />
              ) : <p>{msg.content}</p>}

              {status === 'failed' ? (
                <span className="chat-time chat-time--failed">
                  Not sent ·{' '}
                  <button type="button" onClick={() => onRetry && onRetry(msg.id)}>Retry</button>
                  {' · '}
                  <button type="button" onClick={() => onDiscard && onDiscard(msg.id)}>Delete</button>
                </span>
              ) : status === 'sending' ? (
                <span className="chat-time">Sending…</span>
              ) : lastInGroup ? (
                <span className="chat-time">
                  {timeLabel(msg.created_at)}
                  {msg.id === seenId && <span className="chat-seen"> · Seen</span>}
                </span>
              ) : null}
            </div>
          </div>
        )
      })}
    </>
  )
}
